import * as React from 'react';
import './InputSelect.css';

interface IInputSelectProps {
    id?: string;
    value?: string;
    index?: string;
    array: Map<string, string>;
    width?: string;
    OnChage?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    colorText?: string;
}
class InputSelect extends React.Component<IInputSelectProps> {
    constructor(props: IInputSelectProps) {
        super(props);
    }
    render() {
        let width: string = this.props.width !== undefined ? this.props.width : '136px';
        let id: string = this.props.id !== undefined ? this.props.id : '';
        let index: string = this.props.index !== undefined ? this.props.index : '';
        let colorText: string = this.props.colorText !== undefined ? this.props.colorText : '#000';
        let value: string = '';
        let values: string[] = Array.from(this.props.array.values());
        let keys: string[] = Array.from(this.props.array.keys());
        let className: string = 'input_def_select';

        if (this.props.value !== undefined) value = this.props.value;

        let sty = {
            width: width
        };

        let OptionView = keys.map((keyItem: string, ind: number) => {
            let valueItem: string = values[ind];
            //if (keyItem == value) return <option selected value={keyItem}>{valueItem}</option>
            return (
                <option key={ind} value={keyItem}>
                    {valueItem}
                </option>
            );
        });

        return (
            <select
                style={{ color: colorText }}
                id={id}
                name={index}
                className={className}
                defaultValue={value}
                onChange={this.props.OnChage}
                key={id + value}>
                {OptionView}
            </select>
        );
    }
}

export default InputSelect;
